<div class="row">
    <div class="label py-1">
        <label class="text-xs">{{title}}</label>
    </div>
    <div class="label-input">
        <div class="range">
            <div class="value-display" [style.left.%]="calculatePercentage()">{{value}}</div>
            <input type="range" [min]="min" [max]="max" [step]="step"  class="range1 w-100" [(ngModel)]="value"
                (input)="updateValue($event)" [ngStyle]="{'background': getBackground()}" />
        </div>
    </div>
</div>